import { Component, Input, OnInit, OnDestroy , ElementRef , ViewChild ,  ChangeDetectorRef} from '@angular/core';
import { StudentMessagingService } from '@student/core/messaging/student-messaging.service';



@Component({
        standalone: false,
        selector:       "message-modal" ,
        templateUrl:    "./messagemodal.html",
        styleUrls :     ["./messagemodal.css"]
  })

export class MessageModalComponent implements OnInit, OnDestroy {

	hidden:boolean = true;
	code:string;
    buttonMessage:string = "close";
	message:string = "";
	@ViewChild("mymodalme")
	mymodalme: ElementRef;
	model:any = { code:''
				}
	
	constructor( private changeDRef:ChangeDetectorRef , private mms:StudentMessagingService ){
		
	}
	
	ngOnInit(): void {
		this.mms.setBox(this);
	}
	
	ngOnDestroy(): void {
		
	}
	
	open(msg:string){
		if( msg != undefined && msg != ''){
			this.message = msg;
			this.hidden = false;
			this.changeDRef.detectChanges();
			if (this.mymodalme?.nativeElement != null) {
				this.mymodalme.nativeElement.focus();
			}
		}
	}

    openWithTimeout(msg:string, callback:any  , owner:any){
        if( msg != undefined && msg != ''){
            this.message = msg;

            this.changeDRef.detectChanges();
            this.mymodalme.nativeElement.focus();
            var timeOut = 3;
            this.hidden = false;
            var myVar = setInterval(() => {
                timeOut--;
                this.buttonMessage = "close( "+timeOut+".. )";
            }, 999);
            setTimeout(() => {
                this.close();
                if( callback !=undefined || callback != null )
                    callback.call(owner);
                clearInterval(myVar);
            }, 3000);

        }

    };
    
    openWithTimeoutWithTime(msg:string, callback:any  , owner:any , time:number){
        if( msg != undefined && msg != ''){
            this.message = msg;

            this.changeDRef.detectChanges();
            this.mymodalme.nativeElement.focus();
            var timeOut = time;
            this.hidden = false;
            var myVar = setInterval(() => {
                timeOut--;
                this.buttonMessage = "close( "+timeOut+".. )";
            }, 999);
            setTimeout(() => {
                this.close();
                if( callback !=undefined || callback != null )
                    callback.call(owner);
                clearInterval(myVar);
            }, time * 1000 );

        }

    }
	
	close(){

		this.hidden = true;

	}
	
	modalClose(event:any){
		if( event.keyCode == 27 ){
			this.code = event.code;
			this.close();
		}
	}
}
